import styled from "styled-components";

export const NavigationListItem = styled.li`
    margin: 10px;

a {
    text-decoration: none;
    color: #fff;
}
`;